import { render } from "./specialServiceNumber.vue?vue&type=template&id=1aab6368&scoped=true"
import script from "./specialServiceNumber.vue?vue&type=script&lang=js"
export * from "./specialServiceNumber.vue?vue&type=script&lang=js"

import "./specialServiceNumber.vue?vue&type=style&index=0&id=1aab6368&scoped=true&lang=css"
import "./specialServiceNumber.vue?vue&type=style&index=1&id=1aab6368&lang=css"
script.render = render
script.__scopeId = "data-v-1aab6368"

export default script